export default "__VITE_ASSET__BL4Z2EUd__"